import './globalAnnouncement.scss'

import { Icon } from '@vista-digital/occ-ui'
import { useState } from 'react'
import { setSessionStorage, getSessionStorage } from '../../utilities/sessionStorage'
import { RichTextExtension } from '../../feComponents'
import { observer } from 'mobx-react'
import { cmsDataService } from '../../services'

const sessionKey = 'global-announcement-override'

export const GlobalAnnouncementComponent: React.FC = observer(() => {
    const [isGlobalAnnouncementVisible, setIsGlobalAnnouncementVisible] = useState(true)

    const overrideGlobalAnnouncement = (): void => {
        setSessionStorage<boolean>(sessionKey, true)
        setIsGlobalAnnouncementVisible(false)
    }

    const data = cmsDataService.get().globalAnnouncement

    if (!data) return null

    const { startDateTime, endDateTime, heading, message, daysOfWeek } = data
    const show: boolean = showGlobalAnnouncement(startDateTime, endDateTime, daysOfWeek) && isGlobalAnnouncementVisible

    return (
        <>
            {show && (
                <div className="global-announcement">
                    <div className="container-lg-padding no-bottom-spacing">
                        <div className="global-announcement__content">
                            {heading && <strong className="global-announcement__heading">{heading}</strong>}
                            <RichTextExtension htmlText={message} />
                            <div className="close-button" onClick={overrideGlobalAnnouncement}>
                                <Icon name="cross" />
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
})

const showGlobalAnnouncement = (startDateTime: Date, endDateTime: Date, daysOfWeek: string[]): boolean => {
    const now = new Date()
    const localTimeZoneStartDateTime = new Date(startDateTime)
    const localTimeZoneEndDateTime = new Date(endDateTime)

    const weekday = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
    const currentDay = weekday[now.getDay()]

    let validDayOfWeek = daysOfWeek.some(d => d === currentDay)

    const validDate: boolean = now > localTimeZoneStartDateTime && now < localTimeZoneEndDateTime

    const hasUserOverride = (): boolean => {
        return getSessionStorage<boolean>(sessionKey) ? true : false
    }

    return validDayOfWeek && validDate && !hasUserOverride()
}

export default GlobalAnnouncementComponent
